import React from "react";
const SectionDivider = ({ width = "380px" }) => (
  <div style={{ width: "100%", maxWidth: width, margin: "20px 0" }}>
    <hr
      style={{
        border: 0,
        borderTop: "3px solid #ebeaf3",
        opacity: 1,
        margin: 0,
      }}
    />
  </div>
);

export default SectionDivider;
